
const config_json = {
    Auth: {
        identityPoolId: 'ap-south-1:56a990c9-6237-4564-bb35-3a31b09b7122', //REQUIRED - Amazon Cognito Identity Pool ID
        region: 'ap-south-1', // REQUIRED - Amazon Cognito Region
        userPoolId: 'ap-south-1_L6P6u2X13', //OPTIONAL - Amazon Cognito User Pool ID
        userPoolWebClientId: '29j70cln6jt05tfejrnii8d5d', //OPTIONAL - Amazon Cognito Web Client ID
    },
    Storage: {
      AWSS3: {
          bucket: 'eduvancewebai', //REQUIRED -  Amazon S3 bucket name
          region: 'ap-south-1', //OPTIONAL -  Amazon service region
      }
    },
    "aws_appsync_graphqlEndpoint": "https://zcmc27wcm5evfdyohynoh2nsde.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS"
    
}

export default config_json;